<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增</el-button>
          <el-button
            type="warning"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleDel('DELETE_OPTION','逻辑删除')"
          >删除</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="soldIn()"
          >批量上架</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="soldOut()"
          >批量下架</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑
          </el-button>
          <el-button
            type="warning"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleSingDel(scope.row.id)"
          >删除</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.status=='UNDERCARIAGE'"
            @click.stop="singSoldIn(scope.row.id)"
          >上架</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.status=='PUTAWAY'"
            @click.stop="singSoldOut(scope.row.id)"
          >下架</el-button>
        </template>
        <!-- <template slot-scope="scope" slot="superiorId">
          <el-tag v-if="scope.row.superiorName != null">{{scope.row.superiorName}}</el-tag>
        </template> -->
        <template
          slot-scope="scope"
          slot="search"
        >
          <el-form-item
            label="一级分类"
            size="small"
            style="margin-top: 4px"
          >
            <el-col :md="32">
              <el-select
                v-model="firstSearchClassify"
                placeholder="请选择一级分类"
                required
                clearable
                @change="findSearchSecondClassifyList"
                value-key="id"
              >
                <el-option
                  v-for="firstClassify in firstClassifys"
                  :key="firstClassify.id"
                  :label="firstClassify.name"
                  :value="firstClassify"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item
            label="二级分类"
            size="small"
            style="margin-top: 4px"
          >
            <el-col :md="32">
              <el-select
                v-model="secondSearchClassify"
                placeholder="请选择二级分类"
                required
                clearable
                value-key="i d"
              >
                <el-option
                  v-for="secondClassify in secondSearchClassifys"
                  :key="secondClassify.id"
                  :label="secondClassify.name"
                  :value="secondClassify"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <template
          slot-scope="scope"
          slot="firstClassifyIdForm"
        >
          <el-select
            v-model="firstClassify"
            placeholder="请选择一级分类"
            required
            @change="findSecondClassifyList(true)"
            value-key="id"
          >
            <el-option
              v-for="firstClassify in firstClassifys"
              :key="firstClassify.id"
              :label="firstClassify.name"
              :value="firstClassify"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="secondClassifyIdForm"
        >
          <el-select
            v-model="secondClassify"
            placeholder="请选择二级分类"
            required
            @change="changeSecondClassify"
            value-key="id"
          >
            <el-option
              v-for="secondClassify in secondClassifys"
              :key="secondClassify.id"
              :label="secondClassify.name"
              :value="secondClassify"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="dispatchingForm"
        >
          <div>
            <el-radio
              v-model="dispatching"
              label="EXPRESS"
            >快递</el-radio>
            <el-radio
              v-model="dispatching"
              label="MERCHANT"
            >商家配送</el-radio>
          </div>
        </template>
        <template
          slot-scope="scope"
          slot="provinceForm"
        >
          <el-select
            v-model="currProvince"
            placeholder="请选择省份"
            required
            @change="chooseProvinces"
            value-key="id"
          >
            <el-option
              v-for="item in provinces"
              :key="item.id"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="cityForm"
        >
          <el-select
            v-model="currCity"
            required
            @change="chooseCitys"
            placeholder="请选择城市"
            value-key="id"
          >
            <el-option
              v-for="item in citys"
              :key="item.id"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="areaForm"
        >
          <el-select
            v-model="currArea"
            required
            placeholder="请选择地区"
            value-key="id"
          >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="imgForm"
        >
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList"
            :http-request="fnUploadImgs"
            :show-file-list="false"
          >
            <div
              v-if="'' != img"
              class="el-upload el-upload--picture-img"
            >
              <div>
                <img
                  :src="img"
                  style="width: 200px;"
                />
              </div>
            </div>
            <div
              v-else
              class="el-upload el-upload--car-two"
            >
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template
          slot-scope="scope"
          slot="img"
        >
          <viewer :images="formmaterImage(scope.row.img)">
            <img
              v-for="src in formmaterImage(scope.row.img)"
              :src="src"
              :key="src"
              width="30"
            />
          </viewer>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { engineerGoodsOption } from "@/const/salesCloud/engineerGoodsOption";
import {
  findengineerGoods,
  addEngineerGoods,
  editEngineerGoods,
  delEngineerGoods,
  soldIn,
  soldOut,
} from "@/api/salesCloud/engineerGoods";
import { findClassifyAll } from "@/api/salesCloud/engineerClassify";
import {
  provinceSelect,
  citySelect,
  areasSelect,
} from "@/api/sales/regionSelect";
import { findByLabel, formatterTime } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
export default {
  name: "engineerGoods",
  components: {},
  data() {
    return {
      tableOption: engineerGoodsOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      firstClassifys: [],
      firstClassify: {},
      firstSearchClassify: {},
      secondClassifys: [],
      secondClassify: {},
      secondSearchClassify: {},
      secondSearchClassifys: {},
      dispatching: "EXPRESS",
      provinces: [],
      currProvince: {},
      citys: [],
      currCity: {},
      areas: [],
      currArea: {},
      img: "",
      fileList: [],
    };
  },
  created() {
    this.handleList();
    findClassifyAll().then((res) => {
      let data = JSON.parse(res.data);
      this.firstClassifys = data;
    });
    provinceSelect().then((res) => {
      // let data = JSON.parse(res.data);
      this.provinces = res.data;
    });
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    formmaterImage(row) {
      let str = new Array();
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    searchClear() {
      this.firstSearchClassify = {};
      this.secondSearchClassify = {};
      this.secondSearchClassifys = [];
    },
    findSecondClassifyList(flag) {
      if (null != this.firstClassify.id && undefined != this.firstClassify.id) {
        let obj = {};
        obj.superiorId = this.firstClassify.id;
        findClassifyAll(obj).then((res) => {
          let data = JSON.parse(res.data);
          this.secondClassifys = data;
        });
        if (flag) {
          this.$refs.crud.$refs.tableForm.form.firstClassifyId = this.firstClassify.id;
        }
      } else {
        this.secondClassify = {};
        this.secondClassifys = [];
      }
    },
    findSearchSecondClassifyList() {
      console.log(this.secondSearchClassify);
      if (
        null != this.firstSearchClassify.id &&
        undefined != this.firstSearchClassify.id
      ) {
        let obj = {};
        obj.superiorId = this.firstSearchClassify.id;
        findClassifyAll(obj).then((res) => {
          let data = JSON.parse(res.data);
          this.secondSearchClassifys = data;
          this.secondSearchClassify = {};
        });
      } else {
        this.secondSearchClassify = {};
        this.secondSearchClassifys = [];
      }
    },
    changeSecondClassify() {
      this.$refs.crud.$refs.tableForm.form.secondClassifyId = this.secondClassify.id;
    },
    chooseProvinces() {
      this.currCity = {};
      this.citys = [];
      this.currArea = {};
      this.areas = [];
      console.log(this.currProvince);
      if (this.currProvince) {
        citySelect(this.currProvince.id).then((res) => {
          this.citys = res.data;
        });
      } else {
        this.citys = [];
      }
    },
    chooseCitys() {
      this.currArea = {};
      this.areas = [];
      if (this.currCity) {
        areasSelect(this.currCity.id).then((res) => {
          this.areas = res.data;
        });
      } else {
        this.areas = [];
      }
    },
    async fnUploadImgs(option) {
      this.tableLoading = true;
      console.log(option);
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.img = array[0];
            this.tableLoading = false;
            this.$refs.crud.$refs.tableForm.form.img = array[0];
          })
          .catch((err) => {});
      });
    },
    deletePic(img) {
      let index = this.imgs.indexOf(img);
      if (index > -1) {
        this.imgs.splice(index, 1);
      }
      this.$refs.crud.$refs.tableForm.form.img = this.imgs.join(",");
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findengineerGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findengineerGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != this.firstSearchClassify.id &&
        undefined != this.firstSearchClassify.id
      ) {
        params.firstClassifyId = this.firstSearchClassify.id;
      } else {
        delete params.firstClassifyId;
      }
      if (
        null != this.secondSearchClassify.id &&
        undefined != this.secondSearchClassify.id
      ) {
        params.secondClassifyId = this.secondSearchClassify.id;
      } else {
        delete params.secondClassifyId;
      }
      findengineerGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findengineerGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    clean() {
      this.firstClassify = {};
      this.secondClassify = {};
      this.secondClassifys = [];
      this.currProvince = {};
      this.citys = [];
      this.currCity = {};
      this.areas = [];
      this.currArea = {};
      this.dispatching="EXPRESS"
      this.img = "";
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.clean();
      this.firstClassify = { id: row.firstClassifyId };
      this.findSecondClassifyList(false);
      console.log(row.secondClassifyId);
      this.secondClassify = { id: row.secondClassifyId };
      this.currProvince = { id: row.province };
      this.chooseProvinces();
      this.currCity = { id: row.city };
      this.chooseCitys();
      this.currArea = { id: row.area };
      if (row.img) {
        this.img = row.img;
      }
      this.dispatching= row.dispatching;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      findengineerGoods(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      //   row.firstClassifyId = this.firstClassify.id;
      //   row.secondClassifyId = this.secondClassify.id;
      row.province = this.currProvince.id;
      row.city = this.currCity.id;
      row.area = this.currArea.id;
      row.dispatching = this.dispatching;
      //   row.img = this.imgs.join(",");
      row.brandId = "1111";
      console.log(row);
      addEngineerGoods(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delEngineerGoods(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 批量上架
     *
     **/
    soldIn() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }
      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          soldIn(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 批量上架
     *
     **/
    soldOut() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }
      this.$confirm(`是否确认                                                         下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          soldOut(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleSingDel(id) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          delEngineerGoods(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 上架
     *
     **/
    singSoldIn(id) {
      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          soldIn(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 上架
     *
     **/
    singSoldOut(id) {
      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          soldOut(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      //   row.firstClassifyId = this.firstClassify.id;
      //   row.secondClassifyId = this.secondClassify.id;
      row.province = this.currProvince.id;
      row.city = this.currCity.id;
      row.area = this.currArea.id;
      row.dispatching = this.dispatching;
      //   row.img = this.imgs.join(",");
      row.brandId = "1111";
      console.log(row);
      editEngineerGoods(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    handleDetail(row, index) {
      this.superior = {};
      this.superior.id = row.superiorId;

      this.$refs.crud.rowView(row, index);
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
